import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Card } from '@/components/ui/card';

interface QuickInspectionFormProps {
  formData: any;
  onChange: (data: any) => void;
}

export function QuickInspectionForm({ formData, onChange }: QuickInspectionFormProps) {
  const handleChange = (field: string, value: any) => {
    onChange({ ...formData, [field]: value });
  };

  return (
    <div className="space-y-4">
      <Card className="p-4">
        <h3 className="font-semibold mb-4">Roof Condition</h3>
        <div className="space-y-4">
          <div>
            <Label>Overall Condition</Label>
            <Select
              value={formData.condition}
              onValueChange={(v) => handleChange('condition', v)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select condition" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="excellent">Excellent</SelectItem>
                <SelectItem value="good">Good</SelectItem>
                <SelectItem value="fair">Fair</SelectItem>
                <SelectItem value="poor">Poor</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>Roof Type</Label>
            <Select
              value={formData.roofType}
              onValueChange={(v) => handleChange('roofType', v)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select roof type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="asphalt">Asphalt Shingles</SelectItem>
                <SelectItem value="metal">Metal</SelectItem>
                <SelectItem value="tile">Tile</SelectItem>
                <SelectItem value="flat">Flat/TPO</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>Estimated Age (years)</Label>
            <Input
              type="number"
              value={formData.age || ''}
              onChange={(e) => handleChange('age', e.target.value)}
              placeholder="e.g., 15"
            />
          </div>
        </div>
      </Card>

      <Card className="p-4">
        <h3 className="font-semibold mb-4">Damage Assessment</h3>
        <div className="space-y-4">
          <div>
            <Label>Primary Damage Type</Label>
            <Select
              value={formData.damageType}
              onValueChange={(v) => handleChange('damageType', v)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select damage type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="hail">Hail Damage</SelectItem>
                <SelectItem value="wind">Wind Damage</SelectItem>
                <SelectItem value="storm">Storm Damage</SelectItem>
                <SelectItem value="wear">Normal Wear</SelectItem>
                <SelectItem value="leak">Leak/Water Damage</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>Severity</Label>
            <Select
              value={formData.severity}
              onValueChange={(v) => handleChange('severity', v)}
            >
              <SelectTrigger>
                <SelectValue placeholder="Select severity" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="minor">Minor</SelectItem>
                <SelectItem value="moderate">Moderate</SelectItem>
                <SelectItem value="severe">Severe</SelectItem>
                <SelectItem value="critical">Critical</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div>
            <Label>Notes</Label>
            <Textarea
              value={formData.notes || ''}
              onChange={(e) => handleChange('notes', e.target.value)}
              placeholder="Additional observations..."
              rows={4}
            />
          </div>
        </div>
      </Card>

      <Card className="p-4">
        <h3 className="font-semibold mb-4">Recommendation</h3>
        <Select
          value={formData.recommendation}
          onValueChange={(v) => handleChange('recommendation', v)}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select recommendation" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="full-replacement">Full Replacement</SelectItem>
            <SelectItem value="partial-repair">Partial Repair</SelectItem>
            <SelectItem value="maintenance">Maintenance</SelectItem>
            <SelectItem value="monitor">Monitor</SelectItem>
          </SelectContent>
        </Select>
      </Card>
    </div>
  );
}
